<div class="roomPeople">
  <!--  <div class="roomID">Room {{roomNumber}}</div> -->
  <div style="width:110px;">
    <div class="selectOptions icon icon-dropdown">
      <select [(ngModel)]="adultNum" (change)="setAdultsNumber($event.target.value)" >   <!--  (change)="setRoomNumber()"  -->
        <option *ngFor = "let adult of adults;let isFirst = first" [value] = "'adult' + adult" 
          [selected] = "isFirst">{{adult}} Adults</option>               
      </select> 
    </div>
  </div>

  <div style="width:110px;">
    <div class="selectOptions icon icon-dropdown">
      <select (change)="setChildrenNumber($event.target.value)">
        <option *ngFor = "let children of children;let isFirst = first" [value] = "'child' + children" 
          [selected] = "isFirst">{{children}} Children</option>               
      </select> 
    </div>
    <div class="children" *ngIf="isChildrenSelected()">
      <span>Age of Children</span>
        <div class="selectOptions icon icon-dropdown" *ngFor = "let children of children;let i = index" 
          [ngStyle]="(i >= selectedChildren) && {'border':'none'} ">
          <select *ngIf="i < selectedChildren" (change)="setChildAge($event.target.value, i)">
            <option *ngFor = "let age of childrenAge;let isFirst = first" [value] = "'age' + age" 
              [selected] = "isFirst">{{age}}
            </option>               
          </select> 
        </div>
      </div>
   </div>
 </div>